document.addEventListener("DOMContentLoaded", function() {
  const contactsManagement = document.querySelector('.contacts-management');
  if (contactsManagement === null) {
    return
  }

  const sortButton = document.getElementById('sortButton');
  const sortDropdown = document.getElementById('sortDropdown');
  const selectAll = document.getElementById('selectAll');
  const contactCheckboxes = document.querySelectorAll('.contact-checkbox');
  const actionButtons = document.getElementById('actionButtons');
  const bulkDeleteForm = document.getElementById('bulkDeleteForm');
  const bulkMarkSeenForm = document.getElementById('bulkMarkSeenForm');
  const bulkDeleteIds = document.getElementById('bulkDeleteIds');
  const bulkMarkSeenIds = document.getElementById('bulkMarkSeenIds');

  // Toggle dropdown on button click
  sortButton.addEventListener('click', function (event) {
    event.stopPropagation();
    sortDropdown.style.display = sortDropdown.style.display === 'none' ? 'block' : 'none';
  });

  // Hide dropdown when clicking elsewhere
  document.addEventListener('click', function (event) {
    if (!sortButton.contains(event.target) && !sortDropdown.contains(event.target)) {
      sortDropdown.style.display = 'none';
    }
  });

  // Update action buttons visibility and form data
  function updateActionButtons() {
    const selectedIds = Array.from(contactCheckboxes)
      .filter(cb => cb.checked)
      .map(cb => cb.value);
    actionButtons.style.display = selectedIds.length > 0 ? 'flex' : 'none';
    bulkDeleteIds.value = selectedIds.join(',');
    bulkMarkSeenIds.value = selectedIds.join(',');
  }

  // Select All checkbox logic
  selectAll.addEventListener('change', function () {
    contactCheckboxes.forEach(cb => cb.checked = this.checked);
    updateActionButtons();
  });

  // Individual checkbox logic
  contactCheckboxes.forEach(cb => {
    cb.addEventListener('change', function () {
      selectAll.checked = contactCheckboxes.length === Array.from(contactCheckboxes).filter(cb => cb.checked).length;
      updateActionButtons();
    });
  });

  // Prevent card click from toggling checkbox
  contactCheckboxes.forEach(cb => {
    cb.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  });
})
